module.exports = __webpack_public_path__ + "src/assets/img/StandardVanity2.c72f6b32.jpg";